import * as React from 'react';

import {Modal} from 'shells/modal/modal';

import {CustomizeFieldsWrapper} from './customize-fields-wrapper';

const LIMIT = 8;

type Props = {
    onClose: () => void;
    isOpen: boolean;
    stagesetId: string;
};

export function CustomizeLeadCardModal(props: Props) {
    return (
        <Modal
            headerText='Customize lead cards'
            headerSubtext={`Select up to ${LIMIT} fields to see on your lead cards in the ‘Board’ view for this pipeline.`}
            isOpen={props.isOpen}
            onClose={props.onClose}
            maxWidth={500}
        >
            <CustomizeFieldsWrapper
                entityType='leads'
                onClose={props.onClose}
                stagesetId={props.stagesetId}
                limit={LIMIT}
            />
        </Modal>
    );
}
